import { Box } from "@mui/material";
import { memo, useEffect, useState } from "react";
import { useNotify } from "react-admin";
import { handleHttpError } from "shared/src/utils/errorHandler";

export const FilePreview = memo(({ media }) => {
    const notify = useNotify();
    const [pdfUrl, setPdfUrl] = useState(null);

    useEffect(() => {
        let url = null;
        if (media && media.mimetype === "application/pdf") {
            fetch(media.url)
                .then((response) => response.blob())
                .then((blob) => {
                    url = URL.createObjectURL(blob);
                    setPdfUrl(url);
                })
                .catch((error) => {
                    handleHttpError(error, notify);
                });
        } else {
            setPdfUrl(null);
        }

        return () => {
            if (url) {
                URL.revokeObjectURL(url);
            }
        };
    }, [media, notify]);

    return (
        <Box sx={{ height: "calc(100vh - 135px)", overflowY: "auto", mt: "40px" }}>
            {media && (
                <Box sx={{ height: "100%" }}>
                    {media.mimetype?.startsWith("image/") && (
                        <img
                            src={media.url}
                            alt={media.shortname}
                            style={{
                                border: "1px solid #ccc",
                                maxWidth: "100%",
                                maxHeight: "100%",
                                display: "block",
                            }}
                        />
                    )}
                    {media.mimetype === "application/pdf" && pdfUrl && (
                        <embed
                            src={pdfUrl}
                            type="application/pdf"
                            width="100%"
                            height="100%"
                            style={{
                                border: "1px solid #ccc",
                            }}
                        />
                    )}
                </Box>
            )}
        </Box>
    );
});
